import { Stack } from "@mui/material";
import { LassoFormField } from "../../../components/form/LassoFormField";

const RecipientInfoComponent = ({ control, errors }: any) => {
    return (
        <Stack direction="column" gap={4}>
            <Stack direction="row" gap={4} sx={{ flexDirection: { xs: "column", md: "row" } }}>
                <LassoFormField
                    id="duc-recipient-info-firstName"
                    label="First Name"
                    required
                    controller={{
                        name: 'firstName',
                        control: control,
                        rules: { required: "This field is required", pattern: { value: /^(?!\s*$).+/, message: "Invalid input" } }
                    }}
                    disabled={true}
                    fullWidth
                    error={!!errors?.firstName}
                    helperText={errors?.firstName?.message}
                />
                <LassoFormField
                    id="duc-recipient-info-lastName"
                    label="Last Name"
                    required
                    controller={{
                        name: 'lastName',
                        control: control,
                        rules: { required: "This field is required", pattern: { value: /^(?!\s*$).+/, message: "Invalid input" } },
                    }}
                    disabled={true}
                    fullWidth
                    error={!!errors?.lastName}
                    helperText={errors?.lastName?.message}
                />
            </Stack>

            <Stack direction="row" gap={4} sx={{ flexDirection: { xs: "column", md: "row" } }}>
                <LassoFormField
                    id="duc-recipient-info-degree"
                    label="Degree"
                    required
                    controller={{
                        name: 'degree',
                        control: control,
                        rules: { required: "This field is required", pattern: { value: /^(?!\s*$).+/, message: "Invalid input" },
                            maxLength: { value: 150, message: "Degree cannot exceed 150 characters" } }
                    }}
                    fullWidth
                    error={!!errors?.degree}
                    helperText={errors?.degree?.message}
                />

                <LassoFormField
                    id="duc-recipient-info-institution"
                    label="Institution"
                    required
                    controller={{
                        name: 'institution',
                        control: control,
                        rules: { required: "This field is required", pattern: { value: /^(?!\s*$).+/, message: "Invalid input" },
                            maxLength: { value: 60, message: "Institution cannot exceed 60 characters" } }
                    }}
                    fullWidth
                    error={!!errors?.institution}
                    helperText={errors?.institution?.message}
                />
            </Stack>

            <Stack direction="row" gap={4} sx={{ flexDirection: { xs: "column", md: "row" } }}>
                <LassoFormField
                    id="duc-recipient-info-city"
                    label="City"
                    required
                    controller={{
                        name: 'city',
                        control: control,
                        rules: { required: "This field is required", pattern: { value: /^(?!\s*$).+/, message: "Invalid input" },
                            maxLength: { value: 60, message: "City cannot exceed 60 characters" } }
                    }}
                    fullWidth
                    error={!!errors?.city}
                    helperText={errors?.city?.message}
                />

                <LassoFormField
                    id="duc-recipient-info-state-province"
                    label="State/Province"
                    required
                    controller={{
                        name: 'state',
                        control: control,
                        rules: { required: "This field is required", pattern: { value: /^(?!\s*$).+/, message: "Invalid input" },
                            maxLength: { value: 30, message: "State cannot exceed 30 characters" } }
                    }}
                    fullWidth
                    error={!!errors?.state}
                    helperText={errors?.state?.message}
                />

                <LassoFormField
                    id="duc-recipient-info-country"
                    label="Country"
                    required
                    controller={{
                        name: 'country',
                        control: control,
                        rules: { required: "This field is required", pattern: { value: /^(?!\s*$).+/, message: "Invalid input" },
                            maxLength: { value: 60, message: "Country cannot exceed 60 characters" } }
                    }}
                    fullWidth
                    error={!!errors?.country}
                    helperText={errors?.country?.message}
                />
            </Stack>

            <Stack direction="row" gap={4} sx={{ flexDirection: { xs: "column", md: "row" } }}>
                <LassoFormField
                    id="duc-recipient-info-phone"
                    label="Phone"
                    controller={{
                        name: 'phone',
                        control: control,
                        rules: {  pattern: { value: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, 
                            message: "Invalid input" }  }
                    }}
                    fullWidth
                    error={!!errors?.phone}
                    helperText={errors?.phone?.message}
                />

                <LassoFormField
                    id="duc-recipient-info-email"
                    label="Email"
                    required
                    controller={{
                        name: 'email',
                        control: control,
                        rules: {
                            required: "This field is required", pattern: {
                                value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                message: 'Invalid email address',
                            },
                        }
                    }}
                    disabled={true}
                    fullWidth
                    error={!!errors?.email}
                    helperText={errors?.email?.message}
                />
            </Stack>

        </Stack>

    )
}

export default RecipientInfoComponent;